import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUser } from "api/services/auth";
import Button from "components/Button";
import InputField from "components/FormFields/InputField";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ProfileSettings({ user, close }) {
  const location = useLocation();
  const initialRef = React.useRef(true);

  const [credentials, setCredentials] = React.useState({
    firstName: user?.firstName,
    lastName: user?.lastName,
  });

  const queryClient = useQueryClient();

  const handleCredentialsChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const isDirty =
    user.firstName !== credentials.firstName ||
    user.lastName !== credentials.lastName;

  const updateUserMutation = useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries("user");
      close();
    },
  });

  useEffect(() => {
    if (initialRef.current) {
      initialRef.current = false;
      return;
    }

    close();
  }, [location.pathname]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (user?.id) {
          updateUserMutation.mutate({
            id: user.id,
            firstName: credentials.firstName,
            lastName: credentials.lastName,
          });
        }
      }}
    >
      <InputField
        id="firstName"
        name="firstName"
        label="Adınız"
        placeholder="Adınız"
        value={credentials.firstName}
        onChange={handleCredentialsChange}
      />
      <InputField
        id="lastName"
        name="lastName"
        label="Soyadınız"
        placeholder="Soyadınız"
        value={credentials.lastName}
        onChange={handleCredentialsChange}
      />
      <Button
        isLoading={updateUserMutation.isLoading}
        disabled={!isDirty}
        className="mb-4 w-full fill-white"
      >
        Saxla
      </Button>
    </form>
  );
}
